module.exports = __webpack_public_path__ + "static/future-dad157b795473c5583d3abdeba36f90d.jpg";